const Grey = {
  'grey-f': '#ffffff',
  'grey-c': '#cccccc',
  'grey-d': '#dddddd',
  'grey-9': '#999999',
  'grey-6': '#666666',
  'grey-3': '#333333',
  'grey-2': '#222222',
  'grey-18': '#181818',
  'grey-1': '#111111',
} as const

// 绿色
const Orange = {
  'orange-1': '#F3512B',
  'orange-2': '#F55C1E',
  'orange-3': '#FB6244',
  'orange-4': '#FDB62C',
  'orange-5': '#FCEBE7',
} as const

// 主题色
const Theme = {
  'theme-1': Orange['orange-1'],
  'theme-2': Orange['orange-2'],
  'theme-3': Orange['orange-3'],
} as const

// 填充色
const ColorFill = {
  'color-fill-1': Grey['grey-1'],
  'color-fill-2': Grey['grey-18'],
}

export default {
  ...Grey,
  ...Orange,
  ...Theme,
  ...ColorFill,
} as const
